export default {
  props: {
    forgotPasswordSettings: {
      type: Object,
      required: false,
      default: () => ({
        url: null,
      }),
    },
    loginSettings: {
      type: Object,
      required: false,
      default: () => ({
        url: null,
        csrfToken: null,
        targetPath: null,
      }),
    },
  },
};
